export default "__VITE_ASSET__b0bde070__"